import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './tabbed-table-page.scss';
import CTAButton from '../../Components/CTAButton/CTAButton';
import Field from '../../Components/Field/Field';
import { applicationStatus, MAIN_CONFIG } from '../../../config/main';
import TabbedTable from '../../Components/TabbedTable/TabbedTable';
import Paginator from '../../Components/Paginator/Paginator';
import { debounce } from 'throttle-debounce';
import FilterSelector from '../../Components/FilterSelector/FilterSelector';
import { CreateOptions } from '../../Utility/SelectListLoader';
import KaleidoscopeAPI from '../../Core/KaleidoscopeAPI';
const { USER_CONTEXT } = MAIN_CONFIG;
import { useRouter } from 'next/router';
import Loader from '../Loader/Loader';
import { useSelector } from 'react-redux';
import { reduxPage } from '../../Core/store';
import { toast } from 'react-toastify';
import FlashMessage from '../../Components/FlashMessage/Message';
import TableActionBar from '../TableActionBar/TableActionBar';
import Modal from '../Modal/Modal';
import Close from '../SVG/Close';
import { handleKeyDown } from '../../Utility/ApplicationFormUtility';
import InnerPageHeader from '../InnerPagesHeader/InnerPagesHeader';

const TabbedTablePage = (
    {
        rawTableData = [],
        tableDataFetch,
        tableDataPostFetch,
        allTabData,
        pageTitle,
        identityVisible = true,
        pagination,
        tableDataStatusCounts = {},
        searchPlaceholder = 'Search',
        ctaIcon = null,
        isShowAddBtnPeople = false,
        ctaText = '',
        ctaHide = false,
        ctaAction = () => { },
        getRowMenu = () => { },
        getRowCta = () => { },
        setShowTableActionBar,
        setTableActionBarNumSelected,
        tableActionBarNumSelected,
        setTableActionBarNumTotal,
        tableActionBarNumTotal,
        userContext,
        headerBackgroundColor = '',
        id,
        showSelect = true,
        showRowCta = false,
        overrideHeader = false,
        renderHeaderOverride = () => { },
        noDataDescription,
        noDataCtaLabel,
        noDataCtaOnClick,
        selectedRowsData,
        setSelectedRowsData = () =>{ },
        setSelectedRows = () => { },
        setRemoveRows = () => { },
        setSelectedRowsAll = () => { },
        selectedRows = "",
        selectedRowsAll = "",
        removeRows = "",
        setCurrentSearchTermsScholarship = () => { },
        currentSearchTermsScholarship,
        setCurrentSearchKeyScholarship = () => { },
        setActiveTabTable = () => { },
        accountData,
        clickTableDataView = () => { },
        filters = [],
        instructions = '',
        statusUpdate = false,
        setStatusUpdate = () => { },
        isPeopleShowRole = false,
        setItemCountOnPage,
        itemCountOnPage,
        showRecordPerPage = false,
        totalRecordsCount,
        isScholarshipPage = false,
        scholarshipId,
        bulkApplicationUpdate = false,
        showTableActionBar,
        page = '',
        awardUpdate=false,
        tableActionBarFunctionOpenExportTable = () => { },
        downloadTableActionBar,
        setDownloadTableActionBar,
        showActionBarSpinner,
        setModalState,
        pageData,
        pageType,
        showRecordsPerPage = true,
        setParentTotalRecords = () => { },
        setPaginationData = () => { },
        isDisbursementPage = false,
        updateTotalRecords = false,
        setUpdateTotalRecords = () => { },
        customtableHeaderClass='',
        isDonorScholorshipPage=false,
        showResetPasswordBtn = true,
        handleResetPasswordClick = () => { },
        updateTable = false,
        showBlankHeader,
        updateTableDataFromOutside = false,
        setUpdateTableDataFromOutside = () => {},
        handleClosePopup = () => { },
        handleupdatedDescription = () => { }
    }) => {

    const getSessionStorageKey = (key) => `${pageType}_${key}`;
    const router = useRouter();
    let getClassName=router.pathname==='/client/donations'
    const currentTabIndexRedux = useSelector((state) => state.handleCurrentTabIndex)
    const isBackButtonClicked = useSelector((state) => state.backButtonClicked)
    const getManageFilters = useSelector((state)=> state.manageFilters)
    const initialCurrentPage = isBackButtonClicked ? getManageFilters.page : pagination?.currentPage ?? 1;

    // Gather Scholarship table data
    const [currentTableData, setCurrentTableData] = useState(rawTableData);
    const [currentSortDirection, setCurrentSortDirection] = useState('');
    const [currentSortColumn, setCurrentSortColumn] = useState('');
    const [currentPage, setCurrentPage] = useState(initialCurrentPage);
    const [currentTabIndex, setCurrentTabIndex] = useState(isBackButtonClicked ? currentTabIndexRedux : 0);
    const [prevTabIndex, setPrevTabIndex] = useState(0);
    const [currentSearchTerms, setCurrentSearchTerms] = useState(JSON.parse(sessionStorage.getItem(getSessionStorageKey('searchTerms'))) || (isBackButtonClicked ? getManageFilters?.search?.search_value : ''));
    const [currentSearchTermsKey, setCurrentSearchTermsKey] = useState(isBackButtonClicked ? getManageFilters?.search?.search_keys : '');
    const [totalRecords, setTotalRecords] = useState(pagination ? pagination.totalRecords || 0 : ''); // Tracks ALL/first tab
    const [currentTabTotalRecords, setCurrentTabTotalRecords] = useState(pagination ? pagination.totalRecords || 0 : ''); // Tracks current tab
    const [shouldUpdateTotalRecords, setShouldUpdateTotalRecords] = useState(false);
    const [bulkStatusDropdown, setBulkStatusDropdown] = useState({ label: 'Draft', value: 'Draft' })
    const [bulkStatusSubmitted, setBulkStatusSubmitted] = useState(false)
    // const { perPage } = pagination;
    const user = accountData.user
    const [
        isLoading,
        setIsLoading,
    ] = useState(true)

    const API = new KaleidoscopeAPI({});

    const url = router.query

    const [activeFilters, setActiveFilters] = useState({});
    const [scholarshipFilters, setScholarshipFilters] = useState('');

    /**
     * Returns the columns that should be passed when performing a search.
     * @returns {*}
     */
    const getCurrentSearchableColumns = () => {
        return allTabData[currentTabIndex].table_headers.filter(item => item.enable_search__c).map(item => item.field_api_name__c);
    }

    /**
     * Get the status that the current tab represents.
     * @returns {string|*}
     */
    const getCurrentTabStatusFilter = () => {
        const status = allTabData[currentTabIndex].status_for_api_call__c;

        return status === 'All' ? '' : status;
    }

    const handleBulkApplicationCreate = async (scholarshipId) => {
        setBulkStatusSubmitted(true)
        let slectedScholoershipsAll = localStorage.getItem("slectedScholoershipsAll", "")
        let slectedScholoerships = localStorage.getItem("slectedScholoerships")
        let getRemoveSelectRow = localStorage.getItem("removeSelectRow") ? JSON.parse(localStorage.getItem("removeSelectRow")) : [];
        let data = {
            token: accountData.token,
            is_all_selected: String(slectedScholoershipsAll === "all"),
            selected_application_ids: slectedScholoershipsAll === "all" ? "" : JSON.parse(slectedScholoerships),
            removed_application_ids: slectedScholoershipsAll === "all" ? getRemoveSelectRow : "",
            accountId: accountData.currentAccount.sfid,
            scholarshipId: router?.query?.scholarshipId,
            sub_scholarship_id: scholarshipId,
            search: currentSearchTerms ? { 
                search_keys: getCurrentSearchableColumns().join(','),
                search_value: currentSearchTerms
            } : false,
            status: getCurrentTabStatusFilter(),
            primaryTab:  'Application'
        }
        const response = await API.createBulkApplication(data)
        if (response.success) {
            toast.success(<FlashMessage message={response.message} type='success' />);
            localStorage.removeItem("slectedScholoershipsAll")
            localStorage.removeItem("slectedScholoerships")
            localStorage.removeItem("removeSelectRow")
            setTimeout(() => {
                window.location.reload()
            }, 1000);
        } else {
            toast.error(<FlashMessage type='error' message={response.message}/>);
        }
    }

    // Fetch new table data when page, sort, or search changes
    useEffect(() => {
        updateTableData(currentTabIndex !== prevTabIndex ? { resetPage: true } : '');
        if (currentTabIndex !== prevTabIndex) {
            setPrevTabIndex(currentTabIndex)
        }
        window.scrollTo(0, 0)
    }, [currentTabIndex, statusUpdate, currentPage, currentSortColumn, currentSortDirection, currentSearchTerms, itemCountOnPage, awardUpdate, updateTable]);

    useEffect(() => {
        if(updateTableDataFromOutside){
            setCurrentPage(1)
            updateTableData({resetPage: 1, filters: activeFilters})
            setUpdateTableDataFromOutside(false)
        }
    }, [updateTableDataFromOutside])

    // If the tab changes, reset the page 1
    // useEffect(() => {
    //     updateTableData({ resetPage: true });
    // }, [currentTabIndex])

    /**
     * Fetch new scholarships based on sort request.
     * @param {string} columnName
     * @param {string} currentSortDirection
     */
    const handleSort = async (columnName, currentSortDirection, lastSortPageType) => {
        let newSortDirection
        if(lastSortPageType) {
            newSortDirection = currentSortDirection.toUpperCase();
        } else {
            newSortDirection = currentSortDirection.toUpperCase() === 'ASC' ? 'DESC' : 'ASC';
        }
        setCurrentSortColumn(columnName);
        setCurrentSortDirection(newSortDirection);
    }

    /**
     * Executes a search but only after input has stopped for the specified delay.
     * @type {function}
     */
    const handleSearch = debounce(
        MAIN_CONFIG.SEARCH.DELAY,
        false,
        (value) => {
            handleupdatedDescription(!!value)
            setCurrentPage(1)
            setIsLoading(true)
            setShouldUpdateTotalRecords(true);
            setCurrentSearchTerms(value);
            getSearchKeyForScholarship()
            sessionStorage.setItem(getSessionStorageKey('searchTerms'), JSON.stringify(value));
        });

    // get search key name in donor scholarship
    const getSearchKeyForScholarship = () => {
        if (allTabData[0].table_headers.length > 0) {
            var tempArr = []
            allTabData[0].table_headers.map((item) => {
                if (item.enable_search__c) {
                    tempArr.push(item.field_api_name__c)

                }
            })
            setCurrentSearchTermsKey(tempArr)
        }
    }

    /**
     * Fetches the data for the specified page number.
     * @param {number} page
     */
    const handlePagination = page => {
        setCurrentPage(page)
        setIsLoading(true)
    }

    /**
     * Update the table data respecting sort, search, and pagination.
     * @returns {Promise<void>}
     */
    const updateTableData = async (options = {}) => {
        setIsLoading(true)
        const { resetPage, filter = {}, scholarship = '' } = options;
        let pageToFetch = currentPage;

        // Page is reset to 1 if the tab index was changed
        if (resetPage) {
            pageToFetch = 1;
            setCurrentPage(1);
        }

        const updatedTableData = await tableDataFetch({
            page: pageToFetch,
            per_page: itemCountOnPage && itemCountOnPage.value || 10,
            search: currentSearchTerms ? {
                search_keys: getCurrentSearchableColumns().join(','),
                search_value: currentSearchTerms
            } : false,
            sort: currentSortColumn ? `${currentSortColumn} ${currentSortDirection}` : false,
            status: getCurrentTabStatusFilter(),
            filters: filter || activeFilters,
            scholarship: scholarship || scholarshipFilters
        });

        const tableData = tableDataPostFetch(updatedTableData)
        const { pagination } = updatedTableData;
        setCurrentTableData(tableData);

        setCurrentTabTotalRecords(pagination.totalRecords);
        setParentTotalRecords(pagination.totalRecords);
        setPaginationData(pagination);
        setActiveTabTable(getCurrentTabStatusFilter())
        setCurrentSearchKeyScholarship(getCurrentSearchableColumns().join(','))
        setCurrentSearchTermsScholarship(currentSearchTerms)

        if (shouldUpdateTotalRecords || isDisbursementPage && updateTotalRecords) {
            setTotalRecords(pagination.totalRecords);
            setShouldUpdateTotalRecords(false);
        }
        setIsLoading(false)
    }

    /**
        * Marks filter as active and retrieves
        * updated list of resources
        *
        * @param {object[]} filters
        * @param {string} filters.type
        * @param {string} filters.value
        */

    const addFilters = filters => {
        let scholarship = ''
        if (scholarshipFilters) {
            scholarship = scholarshipFilters
        }
        let dataObj = {};
        filters.map(row => {
            const filterkey = Object.keys(row)[0]
            if (filterkey === "type") {
                scholarship = row.value
            } else {
                dataObj[filterkey] = row[filterkey]
            }
        })
        setActiveFilters(dataObj)
        setScholarshipFilters(scholarship)
        setIsLoading(true)
        setCurrentPage(1)
        updateTableData({ filter: dataObj, scholarship: scholarship });
    }

    /**
     * Removes filters and reloads lists of
     * resources
     *
     * @param {array} filterTypes
     */

    const removeFilters = filterTypes => {
        const currentFilters = activeFilters

        for (let i = 0, total = filterTypes.length; i < total; i++) {
            delete currentFilters[filterTypes[i]]
        }

        setCurrentPage(1)
        setActiveFilters({})
    }
    const updateAll = () => {

        let filer = {
            search: currentSearchTerms ? {
                search_keys: getCurrentSearchableColumns().join(','),
                search_value: currentSearchTerms
            } : false,
            filters: activeFilters,
            scholarship: scholarshipFilters
        }
        ctaAction(filer)
    }

    const [showModal, setShowModal] = useState(false);  
    const handleOpenModal = () => {
      setShowModal(true);
    };
  
    const handleCloseModal = () => {
      setShowModal(false);
    };

    const handleBulkTbfAwardAdd = async (currentAwardAmmount, awardAmountNotes) => {
        setBulkStatusSubmitted(true)
        let slectedScholoershipsAll = localStorage.getItem("slectedScholoershipsAll", "")
        let slectedScholoerships = localStorage.getItem("slectedScholoerships")
        let getRemoveSelectRow = localStorage.getItem("removeSelectRow") ? JSON.parse(localStorage.getItem("removeSelectRow")) : [];
        let data = {
            token: accountData.token,
            is_all_selected: String(slectedScholoershipsAll === "all"),
            selected_application_ids: slectedScholoershipsAll === "all" ? "" : JSON.parse(slectedScholoerships),
            removed_application_ids: slectedScholoershipsAll === "all" ? getRemoveSelectRow : "",
            accountId: accountData.currentAccount.sfid,
            scholarshipId: router?.query?.scholarshipId,
            award_amount: currentAwardAmmount,
            award_amount_notes: awardAmountNotes,
            search: currentSearchTerms ? {
                search_keys: getCurrentSearchableColumns().join(','),
                search_value: currentSearchTerms
            } : false,
            status: getCurrentTabStatusFilter(),
        }

        const response = await API.BulkAwardAmountUpdate(data)
        if (response.success) {
            toast.success(<FlashMessage message={response.message} type='success' />);
            localStorage.removeItem("slectedScholoershipsAll")
            localStorage.removeItem("slectedScholoerships")
            localStorage.removeItem("removeSelectRow")
            setTimeout(() => {
                window.location.reload()
            }, 1000);
        } else {
            toast.error(<FlashMessage type='error' message={response.message} />);
        }
    }

    let primaryColorConvert = (headerBackgroundColor ?? '').toLowerCase();

    const handleBulkStatusUpdate = async () => {

        setBulkStatusSubmitted(true)
        let slectedScholoershipsAll = localStorage.getItem("slectedScholoershipsAll", "")
        var slectedScholoerships = localStorage.getItem("slectedScholoerships")
        var getRemoveSelectRow = localStorage.getItem("removeSelectRow")
            ? JSON.parse(localStorage.getItem("removeSelectRow"))
            : [];


        let data = {
            token: accountData.token,
            is_all_selected: slectedScholoershipsAll === "all" ? "true" : "false",
            selected_application_ids: slectedScholoershipsAll === "all" ? "" : JSON.parse(slectedScholoerships),
            removed_application_ids: slectedScholoershipsAll === "all" ? getRemoveSelectRow : "",
            accountId: accountData.currentAccount.sfid,
            scholarshipId: router.query.scholarshipId,
            scholarship_status: bulkStatusDropdown,
            search: currentSearchTerms ? {
                search_keys: getCurrentSearchableColumns().join(','),
                search_value: currentSearchTerms
            } : false,
            status: getCurrentTabStatusFilter(),

        }

        const response = await API.bulkApplicationStatusUpdate(data)

        if (response.success) {
            toast.success(<FlashMessage message={response.message} />);

            localStorage.removeItem("slectedScholoershipsAll")
            localStorage.removeItem("slectedScholoerships")
            localStorage.removeItem("removeSelectRow")

            setTimeout(() => {
                window.location.reload()
            }, 1000);
        }
    }
    const generateClassForHeading = ()=>{
       return pageType === "APPLICATIONS" ? ' donor-scholarships-application-page__greeting' : ''
    }
    const classNameForHeading = `H1DesktopGreen${generateClassForHeading()}`;

    const idForPages = `donor-page-name-${page}`;
    const renderUserHeader = () => {
        switch (userContext) {
            case USER_CONTEXT.DONOR:
            case USER_CONTEXT.SUPERDONOR:
                return (
                    <>
                       <div className={`donor-scholarships-page__top-copy-tabbed ${customtableHeaderClass}`} id={idForPages}>
                       <div id='donor-scholarships-page__top-copy'>
                            <h1 id='donor-scholarships-page__greeting' className={classNameForHeading}>{pageType === "APPLICATIONS" ? 'Applications' : pageTitle}</h1>

                        </div>
                            {showModal && (
                                <div class="modal-overlay">
                                <Modal >
                                    {/* Modal content */}
                                    <div className="update-status-page">
                                        <div className="update-status-page__header">
                                            <div>
                                                <h1 className='H2DesktopGreen update-status-title'>Update Status</h1>
                                            </div>
                                            <div>
                                            <button onKeyDown={(e)=>handleKeyDown(e,()=>handleCloseModal())} aria-label='Close Modal' className="event-head H6DesktopGrey close-btn" onClick={handleCloseModal}><Close color={MAIN_CONFIG.COLORS.fillGreen} ariaLabel="Close Modal Button" ariaLabelDescription='' tabIndex={-1}/></button>
                                            </div>
                                        </div>
                                        <span className='BodyDefaultBoldBlack'>
                                            {tableActionBarNumSelected} {tableActionBarNumSelected === 1 ? 'Application Selected' : 'Applications Selected'}
                                        </span>

                                        <div className="update-status-page__content">
                                            <Field
                                                placeholder="Status"
                                                type='select'
                                                stylizePlaceholder
                                                id='application-bulk-change-status'
                                                options={CreateOptions(applicationStatus)}
                                                handleChange={(value) => setBulkStatusDropdown(value)}
                                                value={bulkStatusDropdown}
                                                label="Update Status"
                                            />
                                        </div>
                                        <div className="applicant-task__submit">
                                            <CTAButton id='task-page__cta' type='tertiary' onClick={handleBulkStatusUpdate} disabled={!showTableActionBar}>
                                                Update
                                            </CTAButton>
                                        </div>
                                    </div>
                                </Modal>
                                </div>
                            )}
                        <div id='donor-scholarships-page__top-actions' className={`super-donor-applications-landing-page ${!ctaHide ? `flex-direction-column ${userContext}` : `flex-direction-row ${userContext}`}`}>
                                {
                                    !ctaHide && isDonorScholorshipPage && !url.scholarshipId &&<div className='scholorship-page_donor_cta-button'> <CTAButton IconComponent={ctaIcon} onClick={ctaAction}>
                                        {ctaText}
                                    </CTAButton>
                                    </div>
                                }
                            <div className='super-donor-applications-landing-page__top-row'>

                                <Field
                                    placeholder={searchPlaceholder}
                                    type='search'
                                    stylizePlaceholder
                                    handleChange={(value) => handleSearch(value)}
                                    value={currentSearchTerms}
                                    id="scholarships-search-field"
                                />

                                {
                                    !ctaHide && !isDonorScholorshipPage && !url.scholarshipId && <CTAButton IconComponent={ctaIcon} onClick={ctaAction}>
                                        {ctaText}
                                    </CTAButton>
                                }
                            </div>

                            <div className='super-donor-applications-landing-page__second-row'>
                            </div>
                        </div>
                       </div>
                        <TableActionBar
                            showSelect={showSelect}
                            isElements={pageData?.scholarship ? pageData?.scholarship?.elements_review_board__c : false || false} 
                            isArchive={pageData?.scholarship ? pageData?.scholarship?.application_score_archive__c : false || false}  
                            isDonationForm={pageData?.scholarship ? pageData?.scholarship?.form_type__c === "Donation Form" : false || false}
                            visible={showTableActionBar}
                            numSelected={tableActionBarNumSelected}
                            numTotal={tableActionBarNumTotal}
                            getSelectedIds={selectedRows}
                            searchVal={currentSearchTermsScholarship}
                            removeIds={removeRows}
                            selectAllIds={selectedRowsAll}
                            tableActionBarFunctionOpenExport={tableActionBarFunctionOpenExportTable}
                            userContext={userContext}
                            downloadTableActionBar = {downloadTableActionBar}
                            setDownloadTableActionBar = {setDownloadTableActionBar}
                            isLoading = {showActionBarSpinner}
                            setModalState = {setModalState}
                            pageData = {pageData}
                            selectedRowsData = {selectedRowsData} 
                            customClassName={getClassName?"excleOnly":''}
                            bulkApplicationUpdate={bulkApplicationUpdate}
                            handleOpenModal={handleOpenModal}
                            pageType={pageType}
                            handleBulkApplicationCreate={handleBulkApplicationCreate}
                            handleBulkTbfAwardAdd={handleBulkTbfAwardAdd}
                            handleClosePopup={handleClosePopup}
                        />   
                    </>
                );

            case USER_CONTEXT.REVIEWER:
                return (
                    <>
                        <div id='reviewer-home-page__top-copy'>
                            <div id='reviewer-home-page__top-container'>
                                <div className="reviewer-home-page__top-copy__greeting-text">
                                    <h1 id='reviewer-home-page__greeting' className='H1DesktopWhite' style={{ 'color': primaryColorConvert == '#FFFFFF' ? '#1a282c' : '#1a282c' }}>
                                        <span>Hi, {`${user && user.first_name || ''} ${user && user.last_name || ''}`}</span>
                                    </h1>
                                </div>

                                <div className="reviewer-home-page__top-copy__search-box">
                                    <div id='donor-scholarships-page__top-actions'>

                                        <Field
                                            placeholder={searchPlaceholder}
                                            type='search'
                                            stylizePlaceholder
                                            handleChange={handleSearch}
                                        />

                                    </div>
                                </div>

                            </div>
                        </div>
                    </>
                );

            case USER_CONTEXT.RECOMMENDER:
            case USER_CONTEXT.VERIFIER:
            case USER_CONTEXT.NGB:
            case USER_CONTEXT.SCHOOLCOUNSELLOR:
            case USER_CONTEXT.ENDORSEDUSER:
            case USER_CONTEXT.THIRDPARTYCONTRIBUTOR:
                return (
                    <>
                        <div id='reviewer-home-page__top-copy' className="all-third-party-role-header">
                            <div id='reviewer-home-page__top-container'>
                                <div className="reviewer-home-page__top-copy__greeting-text">
                                    <h1 id='reviewer-home-page__greeting' className='H1DesktopGreen'>
                                        {/* <SpaceInvader id='reviewer-home-page__greeting-icon' ariaLabel={`Default profile icon`} ariaLabelDescription={`${user && user.first_name || ''} ${user && user.last_name || ''} default profile image`} /> */}
                                        <span>Hi, {`${user && user.first_name || ''} ${user && user.last_name || ''}`}</span>
                                    </h1>

                                    {/* <span id='reviewer-home-page__greeting-sub' className='BodySmallRegularBlack'>
                                        Here’s a list of recommendations for you to complete
                                    </span> */}
                                </div>


                                <div className="reviewer-home-page__top-copy__search-box">
                                    <div id='donor-scholarships-page__top-actions'>

                                        <Field
                                            placeholder={searchPlaceholder}
                                            type='search'
                                            stylizePlaceholder
                                            handleChange={handleSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            case USER_CONTEXT.UNIVERSITYSTAFF:
            case USER_CONTEXT.HSSTAFF:
            case USER_CONTEXT.COLLEGESTAFF:
            case USER_CONTEXT.DETROITSF:
                return (
                    <>
                        <div className='university-staff-applications-page__inner__content__top__welcome-with-description'>
                            <h1 className='university-staff-name H1DesktopGreen'>
                                {/* <SpaceInvader id='university-staff-home-page__greeting-icon' ariaLabel={`Default profile icon`} ariaLabelDescription={`${user && user.first_name || ''} ${user && user.last_name || ''} default profile image`} /> */}
                                <span className="welcome-user">Hi, {`${user && user.first_name || ''} ${user && user.last_name || ''}`}</span>
                            </h1>
                            <div className='BodyDefaultRegularBlack html-description'>
                                {instructions}
                            </div>
                        </div>
                        <div className="university-staff-applications-page__inner__content__top__filter-with-search">
                            <div className="university-staff-home-page__bottom__search-box">
                                <div className='university-staff-search-action'>
                                    <Field
                                        placeholder={searchPlaceholder}
                                        type='search'
                                        stylizePlaceholder
                                        handleChange={handleSearch}
                                    />
                                </div>
                            </div>

                            <div className="university-staff-filter-combination">
                                <div className="filter-left-section">
                                    <FilterSelector
                                        label={{
                                            singular: '',
                                            plural: '',
                                        }}
                                        count=''
                                        filters={filters}
                                        addFilters={addFilters}
                                        removeFilters={removeFilters}
                                        activeFilters={activeFilters}
                                        filterDataChange={true}
                                        accountData = {accountData}
                                    />
                                </div>
                                {getCurrentTabStatusFilter() === 'Draft' && userContext === USER_CONTEXT.UNIVERSITYSTAFF &&
                                    <div className="filter-right-section">
                                        <CTAButton id='update-all-cta' type='secondary' onClick={updateTableData}>
                                            Refresh
                                        </CTAButton>
                                        <CTAButton id='update-all-cta' type='secondary' disabled={!showSelect} onClick={updateAll}>
                                            Update All
                                        </CTAButton>
                                    </div>
                                }
                            </div>


                        </div>
                    </>
                );
        }
    }
    const getParentClass = () => {
        if (page === 'scholarship') {
            return "stickyTabbed"
        }
    }
    const renderHeader = () => {
        if (overrideHeader) {
            return renderHeaderOverride({ handleSearch, setCurrentPage })
        }
        return renderUserHeader()
    }
    const getPaddingTop = () => {
        if (pageType === 'APPLICATIONS') {
            return '0'
        }
    }
    const paddingTopValue = getPaddingTop()
    return (
    
        <div id={id} style={{ paddingTop: paddingTopValue}} className={getParentClass()}>
                {pageType == "APPLICATIONS" &&
                  <InnerPageHeader pageType={pageType} pageTitle={pageTitle} subtitle={"Applications"} />
                }
            <div id={`${id}__inner`} className={(pageType == 'APPLICATIONS' && userContext == 'DONOR') && 'inner-applications'}>

                <div id={`${id}__top`} style={{backgroundColor: primaryColorConvert}}>
                    {renderHeader()}
                </div>

                <Loader loading={bulkStatusSubmitted} />

                {<TabbedTable
                    allTabData={allTabData}
                    handleSort={handleSort}
                    identityVisible={identityVisible}
                    tableData={currentTableData}
                    tableSortColumn={currentSortColumn}
                    tableSortDirection={currentSortDirection}
                    setShowTableActionBar={setShowTableActionBar}
                    setTableActionBarNumSelected={setTableActionBarNumSelected}
                    setTableActionBarNumTotal={setTableActionBarNumTotal}
                    setSelectedRows={setSelectedRows}
                    setCurrentSearchTermsScholarship={currentSearchTerms}
                    setCurrentSearchKeyScholarship={currentSearchTermsKey}
                    setRemoveRows={setRemoveRows}
                    setSelectedRowsAll={setSelectedRowsAll}
                    getRowMenu={getRowMenu}
                    clickTableDataView={clickTableDataView}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    accountData={accountData}
                    setActiveTabIndex={setCurrentTabIndex}
                    activeTabIndex={currentTabIndex}
                    tabRecordCounts={tableDataStatusCounts}
                    totalRecordCount={totalRecords}
                    currentTabTotalRecordCount={currentTabTotalRecords}
                    tabContainerBackgroundColor={headerBackgroundColor}
                    getRowCta={getRowCta}
                    selectedRowsData={selectedRowsData}
                    setSelectedRowsData={setSelectedRowsData}
                    selectedRows={selectedRows}
                    selectedRowsAll={selectedRowsAll}
                    removeRows={removeRows}
                    showRowCta={showRowCta}
                    showSelect={showSelect}
                    noDataDescription={noDataDescription}
                    noDataCtaLabel={noDataCtaLabel}
                    noDataCtaOnClick={noDataCtaOnClick}
                    isPeopleShowRole={isPeopleShowRole}
                    setItemCountOnPage={setItemCountOnPage}
                    itemCountOnPage={itemCountOnPage}
                    setCurrentPage={setCurrentPage}
                    isScholarshipPage={isScholarshipPage}
                    page = {page}
                    showRecordsPerPage={showRecordsPerPage}
                    updateTotalRecords={updateTotalRecords}
                    setUpdateTotalRecords={setUpdateTotalRecords}
                    isDisbursementPage ={isDisbursementPage}
                    showTableActionBar={showTableActionBar}
                    tableActionBarNumSelected={tableActionBarNumSelected}
                    tableActionBarNumTotal={tableActionBarNumTotal}
                    currentSearchTermsScholarship={currentSearchTermsScholarship}
                    tableActionBarFunctionOpenExportTable={tableActionBarFunctionOpenExportTable}
                    downloadTableActionBar = {downloadTableActionBar}
                    setDownloadTableActionBar = {setDownloadTableActionBar}
                    showActionBarSpinner = {showActionBarSpinner}
                    setModalState = {setModalState}
                    pageData = {pageData}
                    customClassName={getClassName?"excleOnly":''}
                    showResetPasswordBtn = {showResetPasswordBtn}
                    handleResetPasswordClick = {handleResetPasswordClick}
                    pageType = {pageType}
                    showBlankHeader={showBlankHeader}
                />}

            <Paginator
                currentPage={currentPage}
                totalRecords={currentTabTotalRecords}
                perPage={itemCountOnPage ? itemCountOnPage.value : pagination ? pagination.perPage : 10}
                handlePageClick={handlePagination}
                setItemCountOnPage={setItemCountOnPage}
                itemCountOnPage={itemCountOnPage}
                showRecordPerPage={showRecordPerPage}
                setCurrentPage={setCurrentPage}
                tableDataLength={currentTableData.length}
                totalRecordsCount={totalRecordsCount}
                pageType = {pageType}
            />
        </div>
        </div>
       
    );

}

// handle proptypes
TabbedTablePage.propTypes = {
    handleupdatedDescription: PropTypes.func,
    accountData: PropTypes.shape({
        token: PropTypes.string,
        currentAccount: PropTypes.shape({
            sfid: PropTypes.string
        }),
    }),
    showBlankHeader: PropTypes.bool,
    updateTable: PropTypes.bool,
    showSelect: PropTypes.bool,
    updateTableDataFromOutside: PropTypes.bool,
    setUpdateTableDataFromOutside: PropTypes.func,
    pagination: PropTypes.shape({
        currentPage:PropTypes.number
    }),
    handleClosePopup: PropTypes.func,
  };
export default reduxPage(TabbedTablePage)